module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-content",
    staticStyle: {
      "padding": "0 !important",
      "overflow-x": "hidden"
    },
    attrs: {
      "height": "100%"
    }
  }, [(_vm.swiperList.length > 0) ? _c('swiper', {
    attrs: {
      "loop": "",
      "auto": "",
      "list": _vm.swiperList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.categoryList.length > 0) ? _c('grid', _vm._l((_vm.categoryList), function(item) {
    return _c('grid-item', {
      key: item.id,
      attrs: {
        "label": item.title,
        "link": ("/news/cate/" + (item.id))
      }
    }, [_c('img', {
      attrs: {
        "slot": "icon",
        "src": item.iconUrl
      },
      slot: "icon"
    })])
  })) : _vm._e(), _vm._v(" "), _c('panel', {
    attrs: {
      "header": _vm.cateName,
      "list": _vm.list,
      "type": "1"
    }
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('divider', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("没有更多数据了")])], 1)], 1), _vm._v(" "), _c('foot-nav', {
    attrs: {
      "selectBar": "news"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f0ebffc"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/CateIndex.vue
// module id = 685
// module chunks = 0